import * as React from 'react'
import { useSocketService } from '../../context/SocketServiceContext'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
import { MenuItem, Box, Typography } from '@mui/material'
import Kedo from '../../Kedo.js'

interface IAvatarOptions {
    togglePresence?: boolean
    size?: number
    showPresence?: boolean
}

interface User {
    userId: string | number
    username: string
}

interface SelectUserPresenceProps {
    kedo: Kedo
    user: User
    props?: any
    onClick?: () => void
    options?: IAvatarOptions
}

const SelectUserPresence: React.FC<SelectUserPresenceProps> = ({
    kedo,
    user,
    props,
    onClick,
    options,
}) => {
    const socketService = useSocketService()
    const [status, setStatus] = useState('')
    const [avatar, setAvatar] = useState('')

    useEffect(() => {
        //Add check for privacy if user does not to show online
        if (options?.togglePresence) {
            kedo.api()
                .get(kedo.api().getUserProfileEndpoint('me'))
                .then((result) => {
                    if (
                        result.data &&
                        result.data.private_settings &&
                        result.data.private_settings.presence
                    ) {
                        socketService.user
                            .setPresence(result.data.private_settings.presence)
                            .then((resultPresence) => {
                                setStatus(resultPresence)
                            })
                    }
                })
                .catch((errResponse) => console.log(errResponse))
        }
    }, [])

    useEffect(() => {
        //Add check for privacy if user does not to show online
        setStatus(socketService.user.getPresence(user.userId))
    }, [socketService.user.getPresence(user.userId)])

    const setPresence = (e, presence) => {
        if (e && e.stopPropagation) e.stopPropagation()

        const userData = {
            private_settings: { presence: presence },
        }

        kedo.api()
            .patch(kedo.api().getUserProfileEndpoint('me'), userData)
            .then(() => {
                socketService.user
                    .setPresence(presence)
                    .then((resultPresence) => {
                        setStatus(resultPresence)
                    })
            })
            .catch((errResponse) => console.log(errResponse))
    }

    const fetchAvatar = () => {
        kedo.api()
            .getCached(kedo.api().getUserEndpoint(user.userId))
            .then((response) => {
                setAvatar(
                    response.data && response.data.avatar?.length > 0
                        ? kedo
                              .api()
                              .getUserAvatarEndpoint(
                                  user.userId,
                                  response.data.avatar
                              )
                        : null
                )
            })
    }

    useEffect(() => {
        fetchAvatar()
    }, [user])

    const presenceOptions: { key: string; color: string; label: string }[] = [
        { key: 'online', color: 'green', label: kedo.t('Online') || 'Online' },
        { key: 'away', color: 'orange', label: kedo.t('Away') || 'Away' },
        { key: 'busy', color: 'red', label: kedo.t('Busy') || 'Busy' },
        {
            key: 'invisible',
            color: 'gray',
            label: kedo.t('Invisible') || 'Invisible',
        },
    ]

    return (
        <>
            {options?.togglePresence ? (
                <Box sx={{ px: 2, py: 1 }}>
                    <Typography variant="body2" sx={{ opacity: 1 }}>
                        {kedo.t('Set status:') || 'Stel status in:'}
                    </Typography>
                    {presenceOptions.map(({ key, color, label }) => (
                        <MenuItem
                            key={key}
                            onClick={(e) => setPresence(e, key)}
                        >
                            <FontAwesomeIcon
                                icon={faCircle}
                                style={{ color, fontSize: 10, marginRight: 8 }}
                            />
                            <Typography variant="body2" sx={{ opacity: 1 }}>
                                {label}
                            </Typography>
                        </MenuItem>
                    ))}
                </Box>
            ) : null}
        </>
    )
}

export default SelectUserPresence
